import React, { Component } from 'react';
import AppointmentItem from './AppointmentItem';
import isEqual from 'lodash/isEqual';

export default class Appointments extends Component {

    state = {
        appointments: []
    };

    sortByTime = (appointments) => {
        if (appointments.length > 1) {
            let sorted = appointments.sort(
                (a, b) => {
                    return new Date('1970/01/01 ' + a.start_time) - new Date('1970/01/01 ' + b.start_time)
                }
            );

            return sorted;
        } else {
            return appointments;
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(this.props, nextProps);
    }

    render() {
        const { appointments } = this.props;
        let sortedAppointments = this.sortByTime(appointments);

        if (sortedAppointments.length <= 0 || sortedAppointments[0].length <= 0) {
            return (
                <div className="mt-element-list">
                    <div className="mt-list-head list-default" style={{ borderBottom: '1px solid #000' }}>
                        <div className="row">
                            <div className="col-xs-8">
                                <div className="list-head-summary-container">
                                    <div className="col-md-4 col-sm-4 col-xs-4">
                                        <div className="badge badge-warning list-count">{this.props.pending}</div>
                                        <div className="list-label">&nbsp;Pending</div>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-4">
                                        <div className="list-count badge badge-primary">{this.props.completed}</div>
                                        <div className="list-label">&nbsp;Completed</div>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-4">
                                        <div className="list-count badge badge-danger last">{this.props.cancelled}</div>
                                        <div className="list-label">&nbsp;Cancelled</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-list-container list-default no-padding" style={{ overflowY: 'scroll', height: '430px' }}>
                        <div className="mt-list-title uppercase">
                        </div>

                        <h4 style={{ textAlign: 'center' }}>THERE'S NO APPOINTMENTS FOR THIS DATE.</h4>
                    </div>
                </div>
            )
        }

        return (
            <div className="mt-element-list">
                <div className="mt-list-head list-default" style={{ borderBottom: '1px solid #000' }}>
                    <div className="row">
                        <div className="col-xs-8">
                            <div className="list-head-summary-container">
                                <div className="col-md-4 col-sm-4 col-xs-4">
                                    <div className="badge badge-warning list-count">{this.props.pending}</div>
                                    <div className="list-label">&nbsp;Pending</div>
                                </div>
                                <div className="col-md-4 col-sm-4 col-xs-4">
                                    <div className="list-count badge badge-primary">{this.props.completed}</div>
                                    <div className="list-label">&nbsp;Completed</div>
                                </div>
                                <div className="col-md-4 col-sm-4 col-xs-4">
                                    <div className="list-count badge badge-danger last">{this.props.cancelled}</div>
                                    <div className="list-label">&nbsp;Cancelled</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-list-container list-default no-padding" style={{ overflowY: 'scroll', height: '430px' }}>
                    <div className="mt-list-title uppercase">
                    </div>
                    <ul>
                        {sortedAppointments.map((appointment, i) => {
                            if (appointment)
                                return <AppointmentItem key={i} {...appointment} {...this.props} />
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/home/Appointments.js
 **/